import React from "react";
import {HorizontalLoader, ModalActions} from "@mc/mc-legacy";
import {i18n} from "../../i18n/i18n";

export const dialogSubmit = (dispatch, lang, api, successCallback) => {
    return new Promise((resolve, reject) => {
        dispatch(ModalActions.showAsyncWaiting(
            "",
            <div style={{minWidth: 320}}>
                <div className={"pb-2"}>{i18n(lang, "WaitingMessage")}</div>
                <HorizontalLoader/>
            </div>,
            api,
            (result: any) => {
                successCallback && successCallback(result);
            },
            (err) => {
                reject(err);
            }
        ))
    })
}
